<template>
  <v-card class="elevation-2" style="max-width: 100%;">
    <v-card-title class="pb-2 pt-2">
      <span style="font-size: 12px;" class="primary--text">Top Expenses</span>
      <v-tooltip right>
        <v-icon small color="#ccc" slot="activator" class="pl-2">help</v-icon>
        <span
          >Top expenses across various categories on the last 12 months.</span
        >
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn small icon flat @click="lastYear">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <div>{{ currentDate | friendlyDate }}</div>
      <v-btn small icon flat @click="nextYear">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-0">
      <apexchart
        v-if="!isEmpty"
        type="donut"
        width="100%"
        height="240px"
        :options="options"
        :series="topExpenses"
      />
      <v-layout row justify-center align-center v-else class="pa-4">
        <span class="error--text">
          <v-icon class="error--text" small>warning</v-icon>No expenses found
        </span>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import apexchart from "vue-apexcharts";
import { mapGetters } from "vuex";
import accountingFilters from "../../../mixins/accountingFilters";
import currency from "../../../mixins/currency";
import date from "../../../mixins/date";
import BANK_INVOICE_REPORT from "../../../graphql/bank_invoices/report.gql";

export default {
  name: "accountingTopExpenses",
  components: { apexchart },
  mixins: [accountingFilters, currency, date],
  data() {
    return {
      currentDate: new Date(),
      bankInvoiceReports: [],
      loading: false,
      options: {
        labels: [],
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "22px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  color: undefined,
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  color: undefined,
                  offsetY: 16,
                  formatter: this.formatter,
                },
                total: {
                  show: true,
                  showAlways: false,
                  label: "Total",
                  color: "#373d3f",
                  formatter: this.formatterTotal,
                },
              },
            },
          },
        },
      },
      nbInvoicesPerCurrency: {},
    };
  },
  computed: {
    ...mapGetters("commonStore", ["accountTypes"]),
    bankInvoiceReportsData() {
      var ret = this.bankInvoiceReports.filter(
        (e) => e.currency_id === this.currencyId
      );
      if (!this.subsidiaryId) return ret;
      return ret.filter((e) => e.subsidiary_company_id === this.subsidiaryId);
    },
    topExpenses() {
      var accountTypeTotal = {};
      for (var i = 0; i < this.accountTypes.length; i++) {
        let id = this.accountTypes[i].id;
        accountTypeTotal[id] = 0;
      }
      this.bankInvoiceReportsData.forEach((e) => {
        accountTypeTotal[e.account_type_id] += e.total_amount;
      });
      this.options.labels = this.accountTypes.map((e) => e.name);
      this.options.colors = this.accountTypes.map((e) => e.color);

      var ret = this.accountTypes.map((e) => accountTypeTotal[e.id]);
      return this.accountTypes.map((e) => accountTypeTotal[e.id]);
    },
    isEmpty() {
      return this.topExpenses.filter((e) => e !== 0).length === 0;
    },
    monthsFilter() {
      let today = this.currentDate;
      let currentMonth = today.getMonth() + 1;
      let currentYear = today.getYear() + 1900;
      return `((month <= ${currentMonth} && year == ${currentYear}) ||
               (month >  ${currentMonth} && year == ${currentYear - 1}))`;
    },
  },
  methods: {
    formatter(val) {
      return this.inCurrencyFromId(this.currencyId, val);
    },
    formatterTotal(w) {
      let total = w.globals.seriesTotals.reduce((a, b) => {
        return a + b;
      }, 0);
      return this.inCurrencyFromId(this.currencyId, total);
    },
    fetchBankInvoiceReports() {
      this.sendQuery(BANK_INVOICE_REPORT, {
        filter: this.monthsFilter + " && operation_type == debit",
      }).then((data) => {
        this.bankInvoiceReports = data.bank_invoice_reports || [0];
      });
    },
    nextYear() {
      var pastYear = this.currentDate.getFullYear() + 1;
      this.currentDate = new Date(this.currentDate.setFullYear(pastYear));
      this.fetchBankInvoiceReports();
    },
    lastYear() {
      var pastYear = this.currentDate.getFullYear() - 1;
      this.currentDate = new Date(this.currentDate.setFullYear(pastYear));
      this.fetchBankInvoiceReports();
    },
  },
  mounted() {
    this.fetchBankInvoiceReports();
  },
};
</script>
